import { isPlatform } from '@ionic/react';
import { FileOpener } from '@capawesome-team/capacitor-file-opener';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { DocumentContentMap, SupportedDocumentType } from '../types/documents.type';
import { fetchDocument } from 'src/api/payments-detail';
import { TypeDocument } from '../types/documents';

export const getFileUrlFromBuffer = (bufferData: number[], fileType: string): string => {
  const blob = getBlobByBuffer(bufferData, fileType);
  return window.URL.createObjectURL(blob);
};

export const getBlobByBuffer = (bufferData: number[], fileType: string): Blob => {
  return new Blob([new Uint8Array(bufferData).buffer], { type: fileType });
};

export const getBase64FromBuffer = (bufferData: number[], fileType: string): string => {
  const data = btoa(String.fromCharCode(...new Uint8Array(bufferData)));
  return `data:${fileType};base64,${data}`;
};

const getFilePath = (id: string, type: TypeDocument, fileType: SupportedDocumentType) => {
  return `${id}/${type}.${fileType}`;
};

export const openDocumentFile = async (
  id: string,
  type: TypeDocument,
  fileType: SupportedDocumentType
): Promise<void> => {
  const filePath = getFilePath(id, type, fileType);
  const fileBuffer = await fetchDocument(id, type);
  if (!fileBuffer) {
    throw new Error('File not found');
  }
  if (isPlatform('hybrid')) {
    const { uri } = await saveDownloadedFile(filePath, fileBuffer, fileType);
    return openDownloadedFile(uri);
  } else {
    const url = getFileUrlFromBuffer(fileBuffer, DocumentContentMap[fileType]);
    window.open(url, '_blank');
  }
};

export const saveDownloadedFile = async (path: string, bufferData: number[], fileType: SupportedDocumentType) => {
  const data = getBase64FromBuffer(bufferData, DocumentContentMap[fileType]);
  return Filesystem.writeFile({
    path,
    data,
    directory: Directory.Documents,
    recursive: true,
  });
};

export const getDownloadedFileUrl = async (path: string) => {
  const file = await Filesystem.stat({
    path,
    directory: Directory.Documents,
  });
  return file.uri;
};

export const openDownloadedFile = async (path: string) => {
  return FileOpener.openFile({
    path,
  });
};
